import { BaseAppConfig } from '@polybank/shared/config/env';

export type FrontendAppConfig = BaseAppConfig & {
  API_URL: string;
};

export function createBrowserConfig(): FrontendAppConfig {
  return {
    APP_URL: import.meta.env.VITE_APP_URL,
    API_URL: import.meta.env.VITE_API_URL,
    USE_MOCK: import.meta.env.VITE_USE_MOCK === 'true',
    GOCARDLESS_ENV: import.meta.env.VITE_GOCARDLESS_ENV as
      | 'sandbox'
      | 'production',
    APPWRITE_DATABASE_ID: import.meta.env.VITE_APPWRITE_DATABASE_ID,
    APPWRITE_ENDPOINT: import.meta.env.VITE_APPWRITE_ENDPOINT,
    APPWRITE_PROJECT_ID: import.meta.env.VITE_APPWRITE_PROJECT_ID,
  };
}

const appConfig = createBrowserConfig();
export { appConfig };
